import { useUnansweredMessageCount } from '../hooks/useChat';
import { MessageComposer } from '../../messaging/MessageComposer';

interface MessageInputProps {
  onSend: (content: string) => void;
  onTyping: () => void;
  onTypingStop: () => void;
  disabled?: boolean;
  disabledReason?: string;
  /** Conversation the anti-flood counter is scoped to. */
  conversationId?: string;
  /** During a paid chat session the free-message limit does not apply. */
  bypassLimit?: boolean;
}

export function MessageInput({ onSend, onTyping, onTypingStop, disabled, disabledReason, conversationId, bypassLimit }: MessageInputProps) {
  const { data: quota } = useUnansweredMessageCount(bypassLimit ? undefined : conversationId);

  const limitReached = !bypassLimit && (quota ? quota.count >= quota.limit : false);
  const isDisabled = disabled || limitReached;

  const placeholder = disabledReason
    ? disabledReason
    : limitReached
      ? 'Hai raggiunto il limite di 7 messaggi consecutivi'
      : disabled
        ? 'Seleziona una conversazione...'
        : 'Scrivi un messaggio...';

  const topSlot = (
    <>
      {limitReached && (
        <div className="mb-2 rounded-lg bg-brand-orange/10 px-3 py-2 text-xs font-medium text-brand-orange">
          Hai raggiunto il limite di 7 messaggi consecutivi. Potrai scrivere di nuovo quando riceverai una risposta.
        </div>
      )}
      {!isDisabled && (
        <div className="mb-1 flex items-center justify-between">
          <p className="text-[10px] text-neutral-400">
            Invio per inviare · Shift+Invio per a capo
          </p>
          {quota && !bypassLimit && quota.count > 0 && (
            <p className="text-[10px] text-neutral-400">
              {quota.count}/{quota.limit} messaggi in attesa di risposta
            </p>
          )}
        </div>
      )}
    </>
  );

  return (
    <MessageComposer
      onSend={onSend}
      onTyping={onTyping}
      onTypingStop={onTypingStop}
      disabled={isDisabled}
      placeholder={placeholder}
      topSlot={topSlot}
    />
  );
}
